import { render, staticRenderFns } from "./PlatformIgnoreSupplierStockComponent.vue?vue&type=template&id=7f29a59e&"
import script from "./PlatformIgnoreSupplierStockComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformIgnoreSupplierStockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports